import { CheckboxSelectRow } from "@/features/credentials/components/checkbox-select-row";
import type { SeasonTeam } from "@/features/credentials/models/season-team-tree";
import { useTranslation } from "react-i18next";

export function SeasonTeamRow({
  team,
  checked,
  onCheckedChange,
  checkboxId,
}: {
  team: SeasonTeam;
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  checkboxId: string;
}) {
  const { t } = useTranslation();

  return (
    <CheckboxSelectRow
      checkboxId={checkboxId}
      name={team.name || t("credentials.create.fields.unnamed_team")}
      checked={checked}
      onCheckedChange={onCheckedChange}
      className="pl-10"
    />
  );
}
